/* ============================================================
   SolareGlow theme — vanilla JS (cart, drawer, interactions)
   Syncs with Shopify Ajax Cart API.
   ============================================================ */
(function () {
  "use strict";

  var T = window.SGTheme || {};
  var moneyFormat = T.moneyFormat || "${{amount}}";
  var freeShipThreshold = typeof T.freeShipping === "number" ? T.freeShipping : 5000; // cents
  var strings = T.strings || {};

  /* ---------------- money formatting (mirrors Shopify.formatMoney) ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var f = format || moneyFormat;
    function defaultTo(n, p, t, d) {
      n = (n / 100).toFixed(p);
      var parts = n.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + (t || ","));
      var cents = parts[1] ? (d || ".") + parts[1] : "";
      return dollars + cents;
    }
    switch ((f.match(placeholderRegex) || [])[1]) {
      case "amount": value = defaultTo(cents, 2); break;
      case "amount_no_decimals": value = defaultTo(cents, 0); break;
      case "amount_with_comma_separator": value = defaultTo(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = defaultTo(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = defaultTo(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = defaultTo(cents, 0, " "); break;
      case "amount_with_apostrophe_separator": value = defaultTo(cents, 2, "'", "."); break;
      default: value = defaultTo(cents, 2);
    }
    return f.replace(placeholderRegex, value);
  }
  window.SGformatMoney = formatMoney;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- toast ---------------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "sg-toast"; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add("show");
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove("show"); }, 3200);
  }

  /* ============================================================
     CART STATE + DRAWER
     ============================================================ */
  var cartState = null;

  function getCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; renderCart(c); return c; });
  }

  function addToCart(items) {
    var body = Array.isArray(items) ? { items: items } : { items: [items] };
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; renderCart(c); refreshCartPage(c); return c; });
  }

  function bumpCart() {
    var btn = $(".cart-btn");
    if (btn) { btn.classList.add("pop"); setTimeout(function () { btn.classList.remove("pop"); }, 420); }
  }

  function openDrawer() { var d = $("#cart-drawer"); var o = $("#drawer-overlay"); if (d) d.classList.add("open"); if (o) o.classList.add("show"); document.body.style.overflow = "hidden"; }
  function closeDrawer() { var d = $("#cart-drawer"); var o = $("#drawer-overlay"); if (d) d.classList.remove("open"); if (o) o.classList.remove("show"); document.body.style.overflow = ""; }

  function renderCart(cart) {
    // header count
    $all(".cart-count").forEach(function (el) {
      if (cart.item_count > 0) { el.textContent = cart.item_count; el.style.display = ""; }
      else { el.style.display = "none"; }
    });

    // free shipping bar
    var remain = Math.max(0, freeShipThreshold - cart.total_price);
    var pct = Math.min(100, freeShipThreshold ? (cart.total_price / freeShipThreshold) * 100 : 100);
    $all(".js-ship-bar").forEach(function (bar) {
      var msg = bar.querySelector(".js-ship-msg");
      var fill = bar.querySelector(".ship-fill");
      if (fill) fill.style.width = pct + "%";
      if (msg) {
        if (cart.total_price === 0) { msg.innerHTML = (strings.shipStart || "Add items to unlock free shipping ✨"); }
        else if (remain > 0) { msg.innerHTML = (strings.shipAway || "You're <strong>[amount]</strong> away from <strong>free shipping</strong> ✨").replace("[amount]", formatMoney(remain)); }
        else { msg.innerHTML = (strings.shipUnlocked || "<strong>Woohoo!</strong> You've unlocked free shipping 🎉"); }
      }
    });

    // drawer body
    var body = $("#drawer-body");
    if (body) {
      if (!cart.items.length) {
        body.innerHTML = '<div class="cart-empty"><div class="cart-empty-ic">' + icon("cart", 30) + '</div><p>' + (strings.emptyDrawer || "Your bag is feeling light.") + '</p><button class="btn btn-primary js-close-drawer">' + (strings.startGlow || "Start glowing") + '</button></div>';
      } else {
        body.innerHTML = cart.items.map(drawerRow).join("");
      }
    }
    // drawer foot
    var foot = $("#drawer-foot");
    if (foot) {
      if (!cart.items.length) { foot.style.display = "none"; }
      else {
        foot.style.display = "";
        var sub = foot.querySelector(".js-subtotal"); if (sub) sub.textContent = formatMoney(cart.total_price);
        var ck = foot.querySelector(".js-checkout-total"); if (ck) ck.textContent = formatMoney(cart.total_price);
      }
    }
    // drawer header count
    var dh = $("#drawer-count"); if (dh) dh.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";
  }

  function drawerRow(item) {
    var img = item.image ? '<img src="' + resize(item.image, 160) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : "";
    var variant = (item.variant_title && item.variant_title !== "Default Title") ? item.variant_title : (item.product_type || "");
    return '<div class="cart-row" data-key="' + item.key + '">' +
      '<div class="sg-media" style="width:72px;height:72px;flex:none;border-radius:12px;overflow:hidden;">' + img + '</div>' +
      '<div class="cart-row-mid">' +
        '<p class="cart-row-name">' + escapeHtml(item.product_title) + '</p>' +
        (variant ? '<p class="muted cart-row-blurb">' + escapeHtml(variant) + '</p>' : '') +
        '<div class="qty">' +
          '<button class="js-qty" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">' + icon("minus", 15) + '</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button class="js-qty" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">' + icon("plus", 15) + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="cart-row-end">' +
        '<span class="cart-row-price">' + formatMoney(item.final_line_price) + '</span>' +
        '<button class="cart-remove js-qty" data-key="' + item.key + '" data-qty="0">' + (strings.remove || "Remove") + '</button>' +
      '</div>' +
    '</div>';
  }

  function resize(url, w) {
    if (!url) return url;
    return url.replace(/(\.(png|jpg|jpeg|gif|webp))(\?.*)?$/i, "_" + w + "x$1$3");
  }
  function escapeHtml(s) { return (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }

  /* small icon set mirrored from prototype, for JS-rendered bits */
  function icon(name, size) {
    size = size || 22;
    var p = {
      cart: '<path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/>',
      plus: '<path d="M12 5v14M5 12h14"/>',
      minus: '<path d="M5 12h14"/>',
      check: '<path d="m5 13 4 4L19 7"/>'
    }[name] || "";
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }

  /* ---------------- cart page live refresh ---------------- */
  function refreshCartPage(cart) {
    var page = $("#cart-page");
    if (!page) return;
    // remove rows at qty 0, update line prices + totals; simplest: reload section via Section Rendering
    var sectionId = page.getAttribute("data-section-id");
    if (sectionId) {
      fetch("/cart?section_id=" + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.getElementById("cart-page");
          if (fresh) page.innerHTML = fresh.innerHTML;
          bindCartPage();
        });
    }
  }

  /* ============================================================
     EVENT DELEGATION
     ============================================================ */
  document.addEventListener("click", function (e) {
    var t = e.target;

    // open cart drawer
    var cartTrigger = t.closest(".js-cart-toggle");
    if (cartTrigger) { e.preventDefault(); getCart().then(openDrawer); return; }

    // close drawer
    if (t.closest(".js-close-drawer") || t.id === "drawer-overlay") { e.preventDefault(); closeDrawer(); return; }

    // qty change inside drawer
    var qtyBtn = t.closest(".js-qty");
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.getAttribute("data-key");
      var qty = parseInt(qtyBtn.getAttribute("data-qty"), 10);
      var drawer = $("#cart-drawer"); if (drawer) drawer.classList.add("loading");
      changeLine(key, qty).then(function () { if (drawer) drawer.classList.remove("loading"); });
      return;
    }

    // quick add on product card
    var quick = t.closest(".js-quick-add");
    if (quick) {
      e.preventDefault(); e.stopPropagation();
      var vid = quick.getAttribute("data-variant-id");
      if (!vid) { window.location.href = quick.getAttribute("data-url") || "#"; return; }
      quick.classList.add("loading");
      quick.innerHTML = '<span class="sg-spin"></span>';
      addToCart({ id: vid, quantity: 1 }).then(function () {
        quick.classList.remove("loading");
        quick.classList.add("done");
        quick.innerHTML = icon("check", 17) + " " + (strings.added || "Added");
        bumpCart();
        getCart().then(openDrawer);
        setTimeout(function () { quick.classList.remove("done"); quick.innerHTML = icon("plus", 17) + " " + (strings.addToBag || "Add to bag"); }, 1600);
      }).catch(function (err) { quick.classList.remove("loading"); quick.innerHTML = icon("plus", 17) + " " + (strings.addToBag || "Add to bag"); toast((err && err.description) || "Could not add to cart"); });
      return;
    }

    // section add (bundle / generic add buttons)
    var sectionAdd = t.closest(".js-section-add");
    if (sectionAdd) {
      e.preventDefault();
      var sid = sectionAdd.getAttribute("data-variant-id");
      if (!sid) return;
      addToCart({ id: sid, quantity: 1 }).then(function () { bumpCart(); getCart().then(openDrawer); })
        .catch(function (err) { toast((err && err.description) || "Could not add to cart"); });
      return;
    }

    // FAQ / accordion toggle
    var acc = t.closest(".js-acc-head");
    if (acc) {
      var item = acc.closest(".js-acc-item");
      if (item) {
        var wasOpen = item.classList.contains("open");
        var single = item.closest("[data-acc-single]");
        if (single) $all(".js-acc-item.open", single).forEach(function (i) { if (i !== item) { i.classList.remove("open"); var b = i.querySelector(".js-acc-body"); if (b) b.style.maxHeight = "0"; } });
        item.classList.toggle("open", !wasOpen);
        var bodyEl = item.querySelector(".js-acc-body");
        if (bodyEl) bodyEl.style.maxHeight = wasOpen ? "0" : bodyEl.scrollHeight + 40 + "px";
      }
      return;
    }

    // gallery thumb
    var thumb = t.closest(".js-gthumb");
    if (thumb) {
      var gal = thumb.closest(".gallery");
      var idx = thumb.getAttribute("data-index");
      $all(".js-gthumb", gal).forEach(function (b) { b.classList.remove("active"); });
      thumb.classList.add("active");
      $all(".js-gslide", gal).forEach(function (s) {
        var on = s.getAttribute("data-index") === idx;
        s.style.opacity = on ? "1" : "0";
        s.style.pointerEvents = on ? "auto" : "none";
      });
      return;
    }

    // mobile nav
    if (t.closest(".js-menu-open")) { e.preventDefault(); var mn = $("#mobile-nav"); if (mn) { mn.classList.add("open"); document.body.style.overflow = "hidden"; } return; }
    if (t.closest(".js-menu-close") || t.classList.contains("mobile-nav-overlay")) { var mn2 = $("#mobile-nav"); if (mn2) { mn2.classList.remove("open"); document.body.style.overflow = ""; } return; }
  });

  /* ESC closes drawer + mobile nav */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeDrawer(); var mn = $("#mobile-nav"); if (mn) mn.classList.remove("open"); document.body.style.overflow = ""; }
  });

  /* ============================================================
     PDP (main-product) — variant logic + add to cart
     ============================================================ */
  function bindProductForm() {
    var form = $("#product-form");
    if (!form) return;
    var data = window.SGProduct;
    if (!data) return;
    var selected = {};
    var optionInputs = $all("[data-option-index]", form);

    function currentVariant() {
      // Single-variant product or no selectors rendered: nothing to match — use the only variant.
      if (!optionInputs.length || (data.variants && data.variants.length === 1)) {
        return (data.variants && data.variants[0]) || undefined;
      }
      // gather selected option values
      var chosen = [];
      var grouped = {};
      optionInputs.forEach(function (inp) {
        if (inp.tagName === "SELECT") { grouped[inp.getAttribute("data-option-index")] = inp.value; }
        else if (inp.checked) { grouped[inp.getAttribute("data-option-index")] = inp.value; }
      });
      for (var i = 0; i < data.options.length; i++) chosen.push(grouped[i]);
      return data.variants.find(function (v) {
        return v.options.every(function (o, idx) { return o === chosen[idx]; });
      }) || (data.variants.length === 1 ? data.variants[0] : undefined);
    }

    function updateUI() {
      var v = currentVariant();
      var idInput = $("#variant-id", form);
      var addBtn = $("#add-to-cart", form);
      var priceNow = $(".js-price-now");
      var priceWas = $(".js-price-was");
      var priceSave = $(".js-price-save");
      var klarna = $(".js-klarna");
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable || "Unavailable"; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.dataset.price = v.price;
        if (!v.available) { addBtn.innerHTML = strings.soldOut || "Sold out"; }
        else { renderAddLabel(addBtn, v.price); }
      }
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) { priceWas.textContent = formatMoney(v.compare_at_price); priceWas.style.display = ""; if (priceSave) { priceSave.textContent = (strings.save || "Save") + " " + formatMoney(v.compare_at_price - v.price); priceSave.style.display = ""; } }
        else { priceWas.style.display = "none"; if (priceSave) priceSave.style.display = "none"; }
      }
      if (klarna) klarna.textContent = formatMoney(Math.round(v.price / 4));
      // sticky bar price
      var sbPrice = $(".js-sb-price"); if (sbPrice) sbPrice.textContent = formatMoney(v.price);
      // swap gallery to variant image
      if (v.featured_media && v.featured_media.id) {
        var slide = $('.js-gslide[data-media-id="' + v.featured_media.id + '"]');
        if (slide) { var thumbBtn = $('.js-gthumb[data-media-id="' + v.featured_media.id + '"]'); if (thumbBtn) thumbBtn.click(); }
      }
    }

    function renderAddLabel(btn, price) {
      var qtyEl = $("#pdp-qty");
      var q = qtyEl ? parseInt(qtyEl.value || qtyEl.textContent, 10) || 1 : 1;
      btn.innerHTML = (strings.addToBag || "Add to bag") + " · " + formatMoney(price * q);
    }

    optionInputs.forEach(function (inp) {
      inp.addEventListener("change", updateUI);
      inp.addEventListener("click", function () {
        // visual swatch selection
        if (inp.type === "radio") {
          var idx = inp.getAttribute("data-option-index");
          $all('[data-option-index="' + idx + '"]').forEach(function (s) { var lab = s.closest(".bb-swatch"); if (lab) lab.classList.toggle("sel", s.checked); });
        }
      });
    });

    // qty stepper
    var qtyVal = $("#pdp-qty");
    $all(".js-pdp-qty", form).forEach(function (b) {
      b.addEventListener("click", function () {
        var cur = parseInt(qtyVal.value, 10) || 1;
        var nv = Math.max(1, cur + parseInt(b.getAttribute("data-step"), 10));
        qtyVal.value = nv;
        var addBtn = $("#add-to-cart", form);
        var v = currentVariant();
        if (addBtn && v && v.available) renderAddLabel(addBtn, v.price);
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      var q = qtyVal ? parseInt(qtyVal.value, 10) || 1 : 1;
      var addBtn = $("#add-to-cart", form);
      if (addBtn) { addBtn.disabled = true; addBtn.classList.add("loading"); }
      addToCart({ id: v.id, quantity: q }).then(function () {
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove("loading"); addBtn.classList.add("done"); addBtn.innerHTML = icon("check", 18) + " " + (strings.addedBag || "Added to bag"); }
        bumpCart(); getCart().then(openDrawer);
        setTimeout(function () { if (addBtn) { addBtn.classList.remove("done"); renderAddLabel(addBtn, v.price); } }, 1700);
      }).catch(function (err) { if (addBtn) { addBtn.disabled = false; addBtn.classList.remove("loading"); } toast((err && err.description) || "Could not add to cart"); });
    });

    // buy it now
    var buyNow = $("#buy-now", form);
    if (buyNow) buyNow.addEventListener("click", function () {
      var v = currentVariant(); if (!v || !v.available) return;
      var q = qtyVal ? parseInt(qtyVal.value, 10) || 1 : 1;
      addToCart({ id: v.id, quantity: q }).then(function () { window.location.href = "/checkout"; })
        .catch(function (err) { toast((err && err.description) || "Could not add to cart"); });
    });

    updateUI();
  }

  /* sticky add bar on PDP */
  function bindStickyBar() {
    var bar = $("#sticky-bar");
    if (!bar) return;
    var buybox = $(".buybox");
    var footer = $(".footer");
    function onScroll() {
      if (!buybox) return;
      var bbBottom = buybox.getBoundingClientRect().bottom;
      var footTop = footer ? footer.getBoundingClientRect().top : Infinity;
      var show = bbBottom < 0 && footTop > window.innerHeight;
      bar.classList.toggle("show", show);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    var sbAdd = $("#sticky-add");
    if (sbAdd) sbAdd.addEventListener("click", function () {
      var idInput = $("#variant-id");
      var vid = idInput ? idInput.value : sbAdd.getAttribute("data-variant-id");
      if (!vid) return;
      addToCart({ id: vid, quantity: 1 }).then(function () { bumpCart(); getCart().then(openDrawer); })
        .catch(function (err) { toast((err && err.description) || "Could not add to cart"); });
    });
  }

  /* ============================================================
     BEFORE / AFTER SLIDER
     ============================================================ */
  function bindBeforeAfter() {
    $all(".ba-frame").forEach(function (frame) {
      var before = frame.querySelector(".ba-before");
      var handle = frame.querySelector(".ba-handle");
      var pos = 52, dragging = false;
      function set(p) { pos = Math.max(2, Math.min(98, p)); if (before) before.style.clipPath = "inset(0 " + (100 - pos) + "% 0 0)"; if (handle) handle.style.left = pos + "%"; }
      function move(clientX) { var r = frame.getBoundingClientRect(); set(((clientX - r.left) / r.width) * 100); }
      set(pos);
      frame.addEventListener("mousedown", function (e) { dragging = true; move(e.clientX); });
      frame.addEventListener("touchstart", function (e) { dragging = true; move(e.touches[0].clientX); }, { passive: true });
      window.addEventListener("mousemove", function (e) { if (dragging) move(e.clientX); });
      window.addEventListener("touchmove", function (e) { if (dragging) move(e.touches[0].clientX); }, { passive: true });
      window.addEventListener("mouseup", function () { dragging = false; });
      window.addEventListener("touchend", function () { dragging = false; });
    });
  }

  /* ============================================================
     HEADER scroll shadow
     ============================================================ */
  function bindHeader() {
    var hdr = $(".hdr");
    if (!hdr) return;
    function onScroll() { hdr.classList.toggle("hdr-scrolled", window.scrollY > 8); }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     REVEAL ON SCROLL
     ============================================================ */
  function bindReveal() {
    var els = $all(".reveal:not(.in)");
    if (!("IntersectionObserver" in window)) { els.forEach(function (el) { el.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ============================================================
     CART PAGE bindings (qty + promo)
     ============================================================ */
  function bindCartPage() {
    var promoBtn = $(".js-promo-apply");
    if (promoBtn) promoBtn.addEventListener("click", function () {
      var input = $(".js-promo-input");
      var code = (input && input.value || "").trim();
      if (code) window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/cart";
    });
  }

  /* ============================================================
     PRODUCT RECOMMENDATIONS (cross-sell) — fetch if empty
     ============================================================ */
  function bindRecommendations() {
    var sec = $("#cross-sell");
    if (!sec) return;
    var grid = sec.querySelector(".prod-grid");
    if (!grid || grid.children.length > 0) return; // already rendered server-side / manual
    var url = sec.getAttribute("data-rec-url");
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = doc.querySelector("#cross-sell .prod-grid");
      if (fresh && fresh.children.length > 0) { grid.innerHTML = fresh.innerHTML; bindReveal(); }
      else { sec.style.display = "none"; }
    }).catch(function () { sec.style.display = "none"; });
  }

  /* ============================================================
     KACHING BUNDLES — when its widget is present, hide the native
     qty stepper + Add-to-bag (kept in the DOM so Kaching can still
     read the product form), leaving Buy-it-now only.
     Fails safe: if not detected, the native buy box stays as-is.
     ============================================================ */
  function kachingPresent() {
    return !!document.querySelector(
      'kaching-bundles, [data-kaching-bundles], [class*="kaching" i], [id*="kaching" i], [class*="ks-bundle" i], [class*="ks-bundles" i]'
    );
  }
  function bindKaching() {
    var buybox = $(".buybox");
    if (!buybox) return;
    function apply() {
      var on = kachingPresent();
      buybox.classList.toggle("kaching-active", on);
      return on;
    }
    if (apply()) return;
    // Kaching injects asynchronously — poll briefly and observe the DOM until found.
    var tries = 0;
    var iv = setInterval(function () { tries++; if (apply() || tries > 40) clearInterval(iv); }, 250);
    if ("MutationObserver" in window) {
      var mo = new MutationObserver(function () { if (apply()) { mo.disconnect(); clearInterval(iv); } });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    bindHeader();
    bindReveal();
    bindBeforeAfter();
    bindProductForm();
    bindStickyBar();
    bindCartPage();
    bindRecommendations();
    bindKaching();
    getCart();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // re-init on Shopify theme editor section load
  document.addEventListener("shopify:section:load", function () { bindReveal(); bindBeforeAfter(); bindProductForm(); bindStickyBar(); bindHeader(); bindCartPage(); bindKaching(); });
})();
